import React, { useEffect,useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import { Container } from "reactstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb_2Items from "../../../../components/Common/Breadcrumb_2Items";
import showNotification from "../../../../helpers/show_notification";
import { postSubmitForm } from "../../../../helpers/forms_helper";
import preloader from "../../../../helpers/preloader";
import PlaceOrder from "../../../../components/Orders/Equipments/PlaceOrder";

const EquipmentAddOrder = (props) => {
  const role = localStorage.getItem("role")
  const store_id = localStorage.getItem("store_id")

  useEffect(() => {
    loadAllEquipments();
  }, []);

  const loadAllItems = async () => {
    let url ;
    let payload = {};
    if(role==="Central Kitchen Manager"){
      url = process.env.REACT_APP_BASEURL + "storeiteminventories/get_by_store_id"; 
      payload.store_id=store_id
    }else{
      url = process.env.REACT_APP_BASEURL + "branchitems/getforbranch";
      payload = {}
    }
    preloader(true);
    let response = await postSubmitForm(url, payload);
    if (response.status === 1) {
      preloader(false);
      const itemsLable = response.data.filter((d)=>d.is_active).map(item => ({
        ...item.item_details,
        label: `${item.item_details?.category}-${item.item_details?.sub_category} -${item.item_details?.name}(${item.item_details?.brand})`,
        value: item._id
      }));
      {role === "Central Kitchen Manager" ? setAllEquipments(itemsLable) : setAllEquipments(response.data)}
    } else {
      preloader(false);
      showNotification(response.message, "Error");
    }
  };

  const [allEquipments, setAllEquipments] = useState([])
  const loadAllEquipments = async () => {
    preloader(true);
    let url = process.env.REACT_APP_BASEURL + "equipments/getall";
    const response = await postSubmitForm(url, {});
    if (response && response.status === 1) {
      const itemsLable = response.data.map(item => ({
        ...item,
        label: `${item.category}-${item.name}(${item.brand})`,
        value: item._id
      }));
      const SortedData = itemsLable.sort((a,b)=>a.name.localeCompare(b.name))
      preloader(false);
      setAllEquipments(SortedData);
    } else {
      preloader(false);
      showNotification(response.message, "Error");
    }
    
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            alternateTitle={props.t("Equipments")}
            title={props.t("Orders")}
            breadcrumbItem1={props.t("Equipments")}
            breadcrumbItem2={props.t("Add Order")}
          />

          <PlaceOrder 
          equipments={allEquipments}
          />
    
        </Container>
      </div>
    </React.Fragment>
  );
};
export default withRouter(connect(null, {})(withNamespaces()(EquipmentAddOrder)));
